import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
Turbo.config.progressBarDelay = 1000

// Custom Turbo Stream actions
Turbo.StreamActions.remove_class = function () {
  this.targetElements.forEach(element => {
    const classList = this.templateContent.textContent.trim().split(/\s+/)
    element.classList.remove(...classList)
  })
}

Turbo.StreamActions.set_value = function () {
  this.targetElements.forEach(element => {
    element.value = this.getAttribute("value")
  })
}

Turbo.StreamActions.focus = function () {
  this.targetElements.forEach(element => {
    element.focus()
  })
}

// Import all controllers and channels
import "./controllers"
import "./channels"

// Import core libraries
import * as bootstrap from "bootstrap"
import flatpickr from "flatpickr"
import { Chart, registerables } from "chart.js"
import * as DOMHelpers from "./utils/dom_helpers"
import Logger from './lib/logger'
import { setupTurboConfirm } from "./utils/turbo_confirm"

// Register Chart.js components
Chart.register(...registerables)

// Global assignments for legacy compatibility and .js.erb views
window.bootstrap = bootstrap
window.flatpickr = flatpickr
window.Chart = Chart
window.DOMHelpers = DOMHelpers

// Initialize custom confirmation dialogs
setupTurboConfirm()

// Global Google Maps callback (needed for async loading with callback parameter)
window.initGoogleMaps = function () {
  Logger.debug('Google Maps API script loaded; dispatching google-maps-loaded event')
  window.dispatchEvent(new CustomEvent("google-maps-loaded"))
}

Logger.debug('Application.js loaded and global objects initialized')

// Global initialization for non-Stimulus components
document.addEventListener('turbo:render', () => {
  // Add global initializations here if needed
})



